import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';
import type { Messaging } from 'firebase/messaging';
import { config } from '../env-helpers';
import { notification } from 'antd';

const firebaseConfig = {
  apiKey: config.VAROSA_FIREBASE_API_KEY,
  authDomain: config.VAROSA_FIREBASE_AUTH_DOMAIN,
  projectId: config.VAROSA_FIREBASE_PROJECT_ID,
  storageBucket: config.VAROSA_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: config.VAROSA_FIREBASE_MESSAGING_SENDER_ID,
  appId: config.VAROSA_FIREBASE_APP_ID,
  measurementId: config.VAROSA_FIREBASE_MESSAGING_SENDER_ID,
};

const app = initializeApp(firebaseConfig);

export let messaging: Messaging | null = null;

(async () => {
  if (await isSupported()) {
    messaging = getMessaging(app);
  } else {
    notification.warning({
      message: 'Firebase messaging is not supported by this browser. Notifications will not work.',
    });
  }
})();
